import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { ArbetsorderInfoAnteckningarService } from "./arbetsorder-info-anteckningar.service";
import { ArbetsorderInfoAtgardAnteckningarComponent } from "./atgard-anteckningar/arbetsorder-info-atgard-anteckningar.component";
import { ArbetsorderInfoArbetsorderAnteckningarComponent } from "./arbetsorder-anteckningar/arbetsorder-info-arbetsorder-anteckningar.component";

@Component({
    selector: "rask-arbetsorder-info-anteckningar",
    templateUrl: "./arbetsorder-info-anteckningar.component.html",
    styleUrls: ["./arbetsorder-info-anteckningar.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ArbetsorderInfoAtgardAnteckningarComponent,
        ArbetsorderInfoArbetsorderAnteckningarComponent
    ]
})
export class ArbetsorderInfoAnteckningarComponent {
    readonly arbetsorderInfoAnteckningarService = inject(ArbetsorderInfoAnteckningarService);

}
